import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { serverMsg, noInternetMsg } from "../../../config/messageconstant";
import { DistrictJson } from "../../../DynamicFormsJson/MastersJSON/district";
import { getZoneNewForZoneMaster } from "../../../Slice/zone.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { compose } from "@reduxjs/toolkit";
import { withRouter } from "../../../components/withRouter";
import PropTypes from "prop-types";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import AssignDistrictToSales from "./AssignDistrictToSales";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

class DistrictForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      dynamicMasterData: {
        zoneDetail: this.props.zoneList?.zone,
      },
      formData: {},
      rowData: {},
    };
  }

  a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  handledChange = (e, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.zoneList !== nextProps.zoneList) {
      if (this.props.zoneList?.zone !== nextProps.zoneList?.zone) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zone,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const { getZoneNewForZoneMaster, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getZoneNewForZoneMaster().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  onCancel = () => {
    this.props.navigate(-1);
  };

  getFormData = (rowData) => {
    this.setState({ rowData: rowData });
    this.props.navigate(DistrictJson.formPath + "/" + rowData.data.id);
    this.setState({
      tabValue: 1,
    });
  };
  setDataToForm = (data) => {
    this.setState({ formData: data });
  };

  render() {
    const { dynamicMasterData, tabValue, formData, rowData } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            pt: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={DistrictJson.screenTitle}
            showTable={false}
            showBackButton={true}
            showAddButton={false}
            onCancel={this.onCancel}
          />
          <Tabs
            onChange={this.handledChange}
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={"Form "} {...this.a11yProps(0)} />

            <Tab label={"Assign District "} {...this.a11yProps(1)} />
          </Tabs>
          <SwipeableViews index={tabValue} onChangeIndex={this.handleChange}>
            <TabPanel value={tabValue} index={0}>
              <DynamicForm
                padding={false}
                paddingTop={false}
                formPath={DistrictJson.formPath}
                getListById={this.getListById}
                screenTitle={DistrictJson.screenTitle}
                fieldMeta={DistrictJson.fieldMeta}
                dynamicMasterData={dynamicMasterData}
                apiBaseURL={DistrictJson.apiBaseURL}
                showSaveNextBtn={DistrictJson.showSaveNextBtn}
                isEditURL={DistrictJson.isEditURL}
                showTitleAndBack={false}
                showSaveBtn={false}
                getFormData={this.getFormData}
                getFormDataStatic={true}
                getDataForm={true}
                setDataToForm={this.setDataToForm}
                isLog={true}
                type={1}
              />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <AssignDistrictToSales
                padding={false}
                paddingTop={false}
                formPath={DistrictJson.formPath}
                getListById={this.getListById}
                screenTitle={DistrictJson.screenTitle}
                fieldMeta={DistrictJson.fieldMeta}
                dynamicMasterData={dynamicMasterData}
                apiBaseURL={DistrictJson.apiBaseURL}
                showSaveNextBtn={DistrictJson.showSaveNextBtn}
                isEditURL={DistrictJson.isEditURL}
                showTitleAndBack={false}
                rowData={rowData}
              />
            </TabPanel>
          </SwipeableViews>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  zoneList: state.zone,
});
const mapDispatchToProps = {
  getZoneNewForZoneMaster,
  showLoador,
  showNotification,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DistrictForm);
